<template lang="pug">
.listar-areas-table.col-12.cardContainer
    .row.d-flex.justify-content-between.px-3.py-3
        h2 {{ $t('mensagens.territorio.poligonosSelecionados') }}
        el-button(
            style='width: 150px',
            @click.stop='consolidaTerritorio',
            type='primary',
            :disabled='this.territoryTableData.length <= 1'
        )
            | {{ $t('mensagens.territorio.consolidarAreas') }}

    el-table(
        v-if='territoryTableData && territoryTableData.length',
        :data='territoryTableData',
        style='width: 100%'
    )
        el-table-column(
            prop='type',
            :label='$t("mensagens.territorio.labels.tipo")',
            min-width='100px'
        )
        el-table-column(
            prop='codigo',
            :label='$t("mensagens.territorio.labels.codigo")',
            min-width='200px'
        )
        el-table-column(
            :formatter='formatAreaHaTableColumn',
            prop='area_ha',
            :label='$t("mensagens.territorio.labels.areaHa")',
            min-width='200px'
        )
        el-table-column(
            :label='$t("mensagens.operacao.tabela.acoes")',
            width='200px',
            align='center'
        )
            .template.d-flex.justify-content-center(slot-scope='scope')
                el-button(
                    type='danger',
                    @click.stop='deleteTerritory(scope.$index, scope.row)'
                )
                    | {{ $t('mensagens.comuns.deletar') }}

    empty-result(
        v-else,
        :message='$t("mensagens.territorio.voceNaoPossuiAreasAdicionadas")',
        iconClass='mdi-bell-alert-outline'
    )
</template>

<script>
import EmptyResult from '@/components/EmptyResult';
import { mapActions, mapGetters } from 'vuex';
import territorioService from '@/services/TerritorioService';
import EventBus from '@/utils/eventBus';

export default {
    name: 'listAreasTable',
    components: {
        EmptyResult
    },
    data() {
        return {};
    },
    computed: {
        ...mapGetters(['territoryTableData'])
    },
    methods: {
        ...mapActions([
            'removeTerritoryTableData',
            'clearTerritoryTableData',
            'setTerritoryTableData'
        ]),
        deleteTerritory(index, row) {
            if (this.territoryTableData[index].type === 'UPLOAD') {
                this.$emit(
                    'delete-upload-file',
                    this.territoryTableData[index].fileName
                );
            } else {
                this.$root.$emit(
                    'remove-map-layer',
                    this.territoryTableData[index].identificadorGeometria
                );
                this.removeTerritoryTableData(index);
            }
            this.$emit('click-delete-area');
        },
        formatAreaHaTableColumn(row, column, areaHa, index) {
            if (!areaHa) return;
            const area = String(areaHa);
            if (area.includes(',')) {
                let n = areaHa.split(',', 2);
                return n[0] + ',' + n[1].substr(2);
            }
            const options = {
                style: 'decimal',
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            };
            const formatNumber = new Intl.NumberFormat('pt-BR', options);
            return formatNumber.format(areaHa);
        },

        consolidaTerritorio() {
            let listGeometryToSend = {
                geometries: []
            };
            this.territoryTableData.forEach(item => {
                listGeometryToSend.geometries.push({ ...item.geometry });
            });
            territorioService
                .consolidaTerritorio(listGeometryToSend)
                .then(response => {
                    EventBus.$emit(
                        'cadastro-territorio:fechar-modal-car-selecionado'
                    );
                    if (response.status === 200) {
                        this.territoryTableData.forEach(territory => {
                            this.$root.$emit(
                                'remove-map-layer',
                                territory.identificadorGeometria
                            );
                        });

                        this.clearTerritoryTableData();
                        let newTerritoryTableData = {};
                        newTerritoryTableData = {};
                        newTerritoryTableData.area_ha = response.data.areaTotal;
                        newTerritoryTableData.geometry = response.data.geometry;
                        newTerritoryTableData.type = response.data.tipo;
                        newTerritoryTableData.codigo = 'AREA_CONSOLIDADA';

                        const identificadorGeometria = new Date().getTime();

                        newTerritoryTableData.identificadorGeometria =
                            identificadorGeometria;

                        this.setTerritoryTableData(newTerritoryTableData);
                        this.$bus.$emit(
                            'mapa:show-camada-to-edit',
                            newTerritoryTableData.geometry,
                            identificadorGeometria
                        );
                        this.$notify.success({
                            message: this.$t(
                                'mensagens.territorio.territorioConsolidadoComSucesso'
                            )
                        });
                    } else {
                        this.$notify.error({
                            message: this.$t(
                                'mensagens.territorio.erroAoConsolidarTerritorios'
                            )
                        });
                    }
                });
        }
    }
};
</script>

<style lang="scss">
.listar-areas-table {
    .el-table {
        th {
            color: var(--primary);
        }
    }

    .fullHeight {
        height: 100%;
    }

    .cardContainer {
        background-color: var(--white);
        border-radius: 5px;
        padding: 20px;
    }

    .btnDisabled {
        color: var(--disabled-font-color);
        background-color: var(--default-background-color);
        border-color: var(--default-border-color);
        cursor: not-allowed !important;
        pointer-events: none !important;
    }
}
</style>
